import React, { useState } from "react"
import { ReportAPI } from "../../api/apiClient"
import { useUI } from "../../context/UIContext"
import html2pdf from "html2pdf.js"

export default function MaterialStatementVendorWiseReport() {

  const { selectedProjectId, selectedProjectName } = useUI()

  const [qDate,setQDate] = useState("")
  const [endDate,setEndDate] = useState("")
  const [rows,setRows] = useState<any[]>([])
  const [showReport,setShowReport] = useState(false)

  const [expanded,setExpanded] = useState<any>({})

  const toggleRow = (key:any)=>{
    setExpanded((prev:any)=>({
      ...prev,
      [key]:!prev[key]
    }))
  }

  const formatHeaderDate = (dateString:any)=>{
    if(!dateString) return ""
    const date = new Date(dateString)
    return date.toLocaleDateString("en-GB",{
      day:"2-digit",
      month:"short",
      year:"numeric"
    }).replace(/ /g,"-")
  }

  const runReport = async () => {

    if(!selectedProjectId){
      alert("Select Project")
      return
    }

    const data = await ReportAPI.getMaterialStatementVendorWise({
      project:selectedProjectId,
      qDate,
      endDate,
      vendor:-1,
      component:0
    })

    setRows(data)
    setShowReport(true)

  }

  const exportPDF = () => {

    const element = document.getElementById("report-content")
    if(!element) return

    const icons = document.querySelectorAll(".toggle-icon")
    icons.forEach((el:any)=> el.style.display="none")

    const opt:any = {
      margin:10,
      filename:"VendorMaterialStatement.pdf",
      image:{ type:"jpeg", quality:0.98 },
      html2canvas:{ scale:2 },
      jsPDF:{ unit:"mm", format:"a4", orientation:"portrait" }
    }

    const worker = html2pdf().set(opt).from(element)

    worker.toPdf().get("pdf").then((pdf:any)=>{

      const totalPages = pdf.internal.getNumberOfPages()

      for(let i=1;i<=totalPages;i++){

        pdf.setPage(i)
        pdf.setFontSize(10)

        pdf.text(
          `Page ${i} of ${totalPages}`,
          pdf.internal.pageSize.getWidth()/2,
          pdf.internal.pageSize.getHeight()-10,
          {align:"center"}
        )

      }

    }).then(()=>{

      worker.save()
      icons.forEach((el:any)=> el.style.display="")

    })

  }

  const grouped = rows.reduce((acc:any,row:any)=>{

    if(!acc[row.vendor]){
      acc[row.vendor]={}
    }

    const key=row.component+"|"+row.unitName

    if(!acc[row.vendor][key]){
      acc[row.vendor][key]={
        component:row.component,
        unitName:row.unitName,
        receipt:0,
        dates:[]
      }
    }

    acc[row.vendor][key].receipt+=row.receipt

    acc[row.vendor][key].dates.push({
      date:row.date,
      receipt:row.receipt
    })

    return acc

  },{})

  return(

    //<div className="p-10">
    <div className="pt-2 px-6 pb-6">

      {!showReport && (

        <div className="max-w-md">

          <h2 className="text-lg font-semibold mb-6">
            Vendor-wise Material Statement
          </h2>

          <div className="mb-4">
            <div className="text-sm text-gray-500">Project</div>
            <div className="font-medium">{selectedProjectName}</div>
          </div>

          <div className="flex gap-3 mb-6">

            <input
              type="date"
              value={qDate}
              onChange={e=>setQDate(e.target.value)}
              className="border px-3 py-1 rounded"
            />

            <input
              type="date"
              value={endDate}
              onChange={e=>setEndDate(e.target.value)}
              className="border px-3 py-1 rounded"
            />

          </div>

          <button
            onClick={runReport}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Run Report
          </button>

        </div>

      )}

      {showReport && (

        <div className="w-full max-w-4xl">

          <div className="flex justify-end mb-3">

            <button
              onClick={exportPDF}
              className="px-5 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 transition"
            >
              Export PDF
            </button>

          </div>

          <div id="report-content" className="bg-gray-100 shadow">

            {/* HEADER TITLE */}

            <div className="text-sm font-bold mb-4 px-4 pt-3">
              {selectedProjectName}: Vendor-wise Material Statement  
              from {formatHeaderDate(qDate)} to {formatHeaderDate(endDate)}
            </div>

            <div className="grid grid-cols-[5fr_1fr_1fr] bg-slate-700 text-white text-sm px-4 py-2">
              <div>Resource</div>
              <div>Unit</div>
              <div className="text-right">Receipt</div>
            </div>

            {Object.entries(grouped)
              .sort((a:any,b:any)=>{

                if(a[0]==="N/A") return 1
                if(b[0]==="N/A") return -1

                const totalA=(Object.values(a[1]) as any[])
                  .reduce((s,r)=>s+r.receipt,0)

                const totalB=(Object.values(b[1]) as any[])
                  .reduce((s,r)=>s+r.receipt,0)

                return totalB-totalA

              })
              .map(([vendor,resources]:any)=>(

              <div key={vendor}>

                <div className="bg-gray-300 px-4 py-1 text-sm font-medium">
                  {vendor}
                </div>

                {(Object.values(resources) as any[]).map((r:any,i:number)=>{

                  const rowKey = vendor+"_"+i

                  return(

                  <React.Fragment key={i}>

                    <div
                      className="grid grid-cols-[5fr_1fr_1fr] text-sm px-4 py-2 border-b cursor-pointer"
                      onClick={()=>toggleRow(rowKey)}
                    >

                      <div className="pl-6 flex items-center gap-2">

                        <span className="toggle-icon font-bold text-lg">
                          {expanded[rowKey] ? "-" : "+"}
                        </span>

                        {r.component}

                      </div>

                      <div>{r.unitName?.trim()}</div>

                      <div className="text-right">
                        {Number(r.receipt).toLocaleString(undefined,{
                          minimumFractionDigits:2,
                          maximumFractionDigits:2
                        })}
                      </div>

                    </div>

                    {expanded[rowKey] && r.dates.map((d:any,j:number)=>(

                      <div
                        key={j}
                        className="grid grid-cols-[5fr_1fr_1fr] text-sm px-4 py-1 bg-gray-50"
                      >

                        <div className="pl-16">
                          {new Date(d.date).toLocaleDateString("en-GB",{
                            day:"numeric",
                            month:"short",
                            year:"numeric"
                          })}
                        </div>

                        <div></div>

                        <div className="text-right">
                          {Number(d.receipt).toLocaleString(undefined,{
                            minimumFractionDigits:2,
                            maximumFractionDigits:2
                          })}
                        </div>

                      </div>

                    ))}

                  </React.Fragment>

                  )

                })}

              </div>

            ))}

            <div className="h-4 bg-slate-700"></div>

          </div>

          <div className="mt-6">

            <button
              onClick={()=>setShowReport(false)}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
            >
              Back
            </button>

          </div>

        </div>

      )}

    </div>

  )

}